import { render, staticRenderFns } from "./DropDownWallet.vue?vue&type=template&id=5bfe2d76&"
import script from "./DropDownWallet.vue?vue&type=script&lang=js&"
export * from "./DropDownWallet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports